/* globals Class,jui,lp */
var rxUi = window.rxUi;

lp.editor.InfoPanel = Class.create(jui.TabView, {
  initialize: function($super, editor, options) {
    this.editor = editor;
    this.editor.addListener('activePageChanged', this);
    this.editor.addListener('pageRootSelected', this);
    this.editor.addListener('elementActivated', this);
    this.editor.addListener('elementDeactivated', this);
    this.editor.addListener('elementRemoved', this);
    this.open = true;
    this._uiBinding = new rxUi.Binding('InfoPanel');
    var self = this;
    this._uiBinding.filterByEventType('selectTab').ub_subscribe(function (ev) {
      self.tabSelected(ev.tab);
    });
    $super(options);
  },

  isTabLoaded: function() {
    return this.selectedTabViewItem && this.selectedTabViewItem.view;
  },

  installUI: function($super) {
    $super();

    var self = this;
    var selectHandler = function() {
      if (self.isTabLoaded() && Object.isFunction(self.selectedTabViewItem.view.activate)) {
        self.selectedTabViewItem.view.activate();
      }
    };

    this.addTabViewItem({
      id: 'properties',
      label: 'Properties',
      view: null,
      select: selectHandler
    });

    this.addTabViewItem({
      id: 'page',
      label: 'Page Properties',
      view: null,
      select: selectHandler
    });

    this.addTabViewItem({
      id: 'goals',
      label: 'Goals',
      view: null,
      select: selectHandler
    });
  },

  selectTab: function(id) {
    this._uiBinding.onNext({type: 'selectTab', tab: id});
  },

  activePageChanged: function(e) {
    var page = e.data.current;

    if (page.isMain() || page.isLightbox()) {
      this.tabs.get('goals').enable();
      this.replaceTabViewItemView('goals', page.goals.getPropertiesPanel(this));
    } else {
      this.tabs.get('goals').disable();
    }

    if (!page.getConfigValue('showGoalsTab')) {
      this.tabs.get('goals').hide();
    }

    this.getTab('page').setLabel(
      page.getConfigValue('displayName') + ' Properties'
    );
  },

  elementActivated: function(e) {
    var elm = e.data;
    var module = lp.getModule(elm.type);

    if (elm.type === 'lp-pom-root') {
      this.replaceTabViewItemView('page', module.getPropertiesPanel(elm));
      this.setTabViewItem('page');
      this.tabs.get('properties').disable();
    } else {
      if (module && module.getPropertiesPanel) {
        this.replaceTabViewItemView('properties', module.getPropertiesPanel(elm));
      }

      this.setTabViewItem('properties');
      this.tabs.get('properties').enable();
    }
  },

  elementDeactivated: function() {
    this.tabs.get('properties').disable();
  },

  elementRemoved: function(e) {
    var elm = e.data.element;
    if (this.getView('properties') !==  null && this.getView('properties').element === elm) {
      this.editor.setActiveElement(this.editor.page.getRootElement());
    }

    var goalsPanel = this.editor.page.goals.getPropertiesPanel(this);
    goalsPanel.updatePanelState();
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/info_panel.js
// module id = 1005
// module chunks = 0